module.exports = __webpack_public_path__ + "static/media/icon-star-selected.dc73fed1.svg";